import { toast as reactToast, ToastContainer } from 'react-toastify';
import React, { Fragment } from 'react';
import CloseToastButton from '../../components/inputs/buttons/CloseToastButton';
import 'react-toastify/dist/ReactToastify.css';
import './toasts.style.css';

const ToastWrapper = () => (
    <Fragment>
        <ToastContainer
            autoClose={3500}
            className="default-toast-style"
            closeButton={<CloseToastButton />}
            hideProgressBar
            position={reactToast.POSITION.BOTTOM_RIGHT}
        />
    </Fragment>
);

const toast = (component, options) => (
    reactToast(component, options)
);
export {
    toast,
};

export default ToastWrapper;
